<template>
  <div>
    <div>
      <p><b>עיר עבודה (2)</b></p>
      <input @input="searchCity($event.target.value)" v-model="search_term" class="outlined" placeholder="אנא הקלד/י עיר מגורים...">
    </div>
    <div class="search_results">
      <p @click="chooseCity(result)" v-for="result in search_results" :key="result.num" v-html="$sanitize(result.text)" class="search_result m-0"></p>
      <p v-if="search_error" class="search_error m-0">{{ search_error }}</p>
      <div v-if="is_choosing_city" class="loading_container is-flex is-align-items-center is-justify-content-center">
        <div class="loading_opacity"></div>
        <div class="loading relative"></div>
      </div>
    </div>
    <div>
      <div v-for="picked_city in picked_cities" :key="picked_city.num"
           class="is-flex is-align-items-center is-justify-content-space-between faded_border_bottom" style="width: 310px; margin-top: 10px;">
        <p v-html="$sanitize(picked_city.cityName)"></p>
        <a @click="removePickedCity(picked_city)" class="button is-danger">הסר</a>
      </div>
    </div>
  </div>
</template>
<script>
// Jira b270b72c: the city search used to have no error handling and no stale-response guard, so a
// failed Jobmaster call (or a late answer for an older keystroke) left an empty list with no
// explanation, and a second pick was refused instead of replacing the city.
export const JOBMASTER_CITY_SEARCH_DEBOUNCE_MS = 300
export const JOBMASTER_CITY_SEARCH_ERROR = 'החיבור לג\'ובמאסטר נכשל, נסי שוב בעוד רגע'

export default {
  name: 'outsource-jobmaster-cities',
  props: ['picked_cities'],
  data () {
    return {
      is_choosing_city: false,
      search_results: [],
      search_term: '',
      search_error: '',
      search_timer: null,
      search_request_id: 0
    }
  },
  beforeDestroy () {
    clearTimeout(this.search_timer)
  },
  methods: {
    searchCity (search_term) {
      clearTimeout(this.search_timer)
      // Any answer still in flight belongs to an older term from here on.
      this.search_request_id++
      this.search_error = ''
      if (!search_term || search_term.trim().length == 0) {
        this.search_results = []
        return
      }
      this.search_timer = setTimeout(() => this.runSearch(search_term), JOBMASTER_CITY_SEARCH_DEBOUNCE_MS)
    },
    runSearch (search_term) {
      const request_id = ++this.search_request_id
      return this.$network_utils.caller.request('get', '/outsource_data/search_jobmaster_city', 'admin_headers', { search_term }).then(response => {
        if (request_id != this.search_request_id) return
        if (!response || !Array.isArray(response.list)) {
          this.showSearchError()
          return
        }
        this.search_results = response.list
      }).catch(error => {
        if (request_id != this.search_request_id) return
        const data = error && error.response && error.response.data
        this.showSearchError(data && data.error)
      })
    },
    showSearchError (message) {
      this.search_results = []
      this.search_error = message || JOBMASTER_CITY_SEARCH_ERROR
      this.$utils.emit('show_toast', { text: this.search_error })
    },
    chooseCity (city) {
      clearTimeout(this.search_timer)
      this.search_request_id++
      let city_name = this.removeHTMLTags(city.text)
      this.search_results = []
      this.search_term = ''
      this.search_error = ''
      // Still one city only: a new pick replaces the current one instead of being refused.
      this.$emit('input', [{
        num: city.num,
        cityName: city_name,
        cityNameH: city_name
      }])
    },
    removeHTMLTags (html) {
      // A document from createHTMLDocument has no browsing context, so nothing in it loads or
      // runs: unlike innerHTML on a div of the live document, an <img onerror> inside a supplier
      // city name never fires.
      const inert_document = document.implementation.createHTMLDocument('')
      inert_document.body.innerHTML = String(html || '')
      return inert_document.body.textContent || ''
    },
    removePickedCity (city_to_remove) {
      let picked_cities = this.picked_cities.filter(picked_city => picked_city.num != city_to_remove.num)
      this.$emit('input', picked_cities)
    }
  }
}
</script>
<style scoped>
  .search_error{
    color: #cc0f35;
  }
  .loading_container{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .loading_opacity{
    opacity: 0.6;
    position: absolute;
    background-color: white;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
</style>
